/* eslint-disable @typescript-eslint/no-unsafe-return */

import { AxiosResponse } from "axios";

export const mapInitResponse =
    (resp: AxiosResponse) => resp.data;

